import React from 'react';
import { ReactComponent as BoltIcon } from 'new/components/icons/boltFill.svg';
import { ReactComponent as PauseIcon } from 'new/components/icons/pauseFill.svg';
import { ReactComponent as OpacityIcon } from 'new/components/icons/opacity.svg';
import { ReactComponent as SignalIcon } from 'new/components/icons/signalCellularAltFilled.svg';
import Constants from 'js/Constants';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { useTheme } from '@mui/material';

const { SourceStatus: Statuses } = Constants;

interface SourceStatusProps {
  status: string;
}

const statusMapper = {
  [Statuses.INIT]: {
    label: 'Initialized',
    color: 'color-greyscale-600',
    icon: OpacityIcon,
  },
  [Statuses.ACTIVE]: {
    label: 'Active',
    color: 'color-success-800',
    icon: BoltIcon,
  },
  [Statuses.PAUSED]: {
    label: 'Paused',
    color: 'color-warning-700',
    icon: PauseIcon,
  },
  [Statuses.RATE_LIMITED]: {
    label: 'Rate Limited',
    color: 'color-danger-700',
    icon: SignalIcon,
  },
};

const styles = {
  label: {
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '16px',
  },
  icon: {
    width: '12px',
    height: '12px',
  },
};

export const SourceStatus = (props: SourceStatusProps) => {
  const map = statusMapper[props.status] || statusMapper.INIT;
  const Icon = map.icon;
  const theme = useTheme();
  const color = map.color ? `var(--${map.color})` : 'var(--color-greyscale-600)';
  return (
    <Stack direction="row" gap="4px" alignItems="center">
      <Icon
        style={{
          fill: color,
          ...styles.icon,
        }}
      />
      <Typography variant="subtitle1" style={{ ...styles.label, color }}>
        {map.label}
      </Typography>
    </Stack>
  );
};
